interface SmartContractWallet1CTPromptState {
  isPrivyEmbeddedWallet: boolean;
  isSingleSignatureSession: boolean;
  isSmartContractWallet: boolean;
}

export function shouldShowSmartContractWallet1CTPrompt({
  isPrivyEmbeddedWallet,
  isSingleSignatureSession,
  isSmartContractWallet,
}: SmartContractWallet1CTPromptState) {
  return (
    isSmartContractWallet &&
    !isPrivyEmbeddedWallet &&
    !isSingleSignatureSession
  );
}
